module.exports = __webpack_public_path__ + "static/media/movi-rate.81fa1e95.png";